import axios from "axios";
import { BASE_URL } from "./type";

export function getProducts(category, page, pagenation = 1, search = '') {
    const params = new URLSearchParams({ page });
    if (pagenation) params.set('pagenation', '1');
    if (category) params.set('category', category);
    if (search) params.set('search', search);
    return axios.get(`${BASE_URL}product?${params.toString()}`);
}

export function getProduct(id) {
    return axios.get(BASE_URL + "product/" + id);
}

export function saveProduct(formData) {
    return axios.post(BASE_URL + "product", formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
    });
}

export function deleteProduct(id) {
    return axios.delete(BASE_URL + "product/" + id);
}

export function getRecommendedProducts() {
    return axios.get(`${BASE_URL}product?api=true`);
}

export function duplicateProduct(id) {
    return axios.post(`${BASE_URL}product/${id}/duplicate`);
}